
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/mcp-agent-setup",
      function () {
        return require("private-next-pages/docs/mcp-agent-setup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/mcp-agent-setup"])
      });
    }
  